import axios from './../plugins/private-api-axios'

export const userService = {
    urlPrefix: '/users',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async createUser (
        username,
        firstName,
        lastName,
        phoneNumber,
        email,
        role,
        password
    ) {
        try {
            return await axios.post(this.urlPrefix, {
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber,
                email: email,
                username: username,
                password: password,
                role: role
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getUsers (page, perPage, username, role) {
        let urlBuilder = {}

        if (null != page && null != perPage) {
            urlBuilder.skip = (page - 1) * perPage
            urlBuilder.take = perPage
        }

        if (null != username) {
            urlBuilder.username = `%${username}%`
        }

        if (null != role) {
            urlBuilder.role = role
        }

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getUser (uuid) {
        try {
            return await axios.get(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async editUser (
        id,
        username,
        firstName,
        lastName,
        phoneNumber,
        email,
        role,
        password
    ) {
        let data = {
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            email: email,
            username: username,
            role: role
        }

        if (null !== password) {
            data.password = password
        }

        try {
            return await axios.put(`${this.urlPrefix}/${id}`, data, this.config)
        } catch (e) {
            throw e
        }
    },
    async deleteUser (username) {
        try {
            return await axios.delete(`${this.urlPrefix}/${username}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async assignDriverToVehicle (username, vehicleId) {
        try {
            return await axios.put(`${this.urlPrefix}/assignDriverToVehicle/${vehicleId}`, {
                username: username
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async detachDriverFromVehicle (username, vehicleId) {
        try {
            return await axios.put(`${this.urlPrefix}/detachDriverFromVehicle/${vehicleId}`, {
                username: username
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async assignUserToFleet (username, fleetsIds) {
        try {
            return await axios.put(`${this.urlPrefix}/updateUserInFleets`, {
                username: username,
                vehicleFleetsIds: fleetsIds
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getAssignedFleets (username) {
        try {
            return await axios.get(`${this.urlPrefix}/getAssignedVehiclesFleetsToUser/${username}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateUserService = (accessToken) => {
    userService.config.headers.Authorization = accessToken
}

export default userService
